import { activeModule } from "../providers/active-module";
import { Config as CoreConfig } from "./src/shared/config";
import { AppSettings } from "./src/shared/types/entities";
import { Config as FourTimeConfig } from "../4time/config";
import { Config as IrsKomConfig } from "../IrsKom/config";
import { Config as Parhato2Config } from "../parhato2/config";

const modulesConfig: Record<string, any> = {
  "4TIME": FourTimeConfig,
  IRSKOM: IrsKomConfig,
  PARHATO2: Parhato2Config,
};

const createInitialConfig = (): AppSettings => {
  const moduleName = activeModule;

  if (modulesConfig[moduleName]) {
    return { ...CoreConfig, ...modulesConfig[moduleName] };
  }

  return CoreConfig;
};

let appConfig: AppSettings = createInitialConfig();
let lastPatchedSettings: Partial<AppSettings> | undefined;

export const getAppConfig = (): AppSettings => appConfig;

export const patchAppConfig = (settings: Partial<AppSettings>): void => {
  if (lastPatchedSettings === settings) {
    return;
  }

  lastPatchedSettings = settings;
  appConfig = { ...appConfig, ...settings };
};
